import styled from 'styled-components';

export const ContractNotFoundWrapper = styled.section`
  display: flex;
  justify-content: center;
  padding-top: 6.5rem;
  min-height: 27.25rem;
`;
